module.exports = __webpack_public_path__ + "img/logo-wide-white.084c5ecf.png";